import React, { useState } from "react";
import { Star, Clock, ChevronDown, ChevronUp } from "lucide-react";

const ExperienceItem = ({ experience }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const isPending = experience.status === "Pending";
  
  return (
    <div 
      className="bg-white rounded-xl border border-slate-200 overflow-hidden hover:shadow-md transition-shadow cursor-pointer"
      onClick={() => setIsExpanded(!isExpanded)}
    >
      <div className="p-4">
        <div className="flex items-start justify-between mb-2">
          <div className="flex-1 min-w-0">
            <p className="font-bold text-slate-800 text-base line-clamp-1">{experience.experienceName}</p>
            <p className="text-sm text-slate-500 mt-1">
              with {experience.creatorName}
            </p>
          </div>
          <div className="ml-3 flex-shrink-0">
            {isExpanded ? <ChevronUp size={20} className="text-slate-400" /> : <ChevronDown size={20} className="text-slate-400" />}
          </div>
        </div>
        
        <div
          className={`inline-flex items-center gap-2 text-xs font-semibold px-2 py-1 rounded-full ${
            isPending
              ? "bg-amber-100 text-amber-700"
              : "bg-green-100 text-green-700"
          }`}
        >
          {isPending ? <Clock size={14} /> : <Star size={14} />}
          {experience.status}
        </div>
        
        <p className="text-xs text-slate-400 mt-3 pt-3 border-t border-slate-100">
          Requested on {experience.requestDate}
        </p>
        
        {isExpanded && (
          <div className="mt-3 pt-3 border-t border-slate-100 space-y-2">
            <div>
              <p className="text-xs font-semibold text-slate-700 mb-1">Description:</p>
              <p className="text-sm text-slate-600">
                {experience.description || "A personalized experience tailored to your interests."}
              </p>
            </div>
            {experience.duration && (
              <div>
                <p className="text-xs font-semibold text-slate-700 mb-1">Duration:</p>
                <p className="text-sm text-slate-600">{experience.duration}</p>
              </div>
            )}
            {experience.price && (
              <div>
                <p className="text-xs font-semibold text-slate-700 mb-1">Price:</p>
                <p className="text-sm font-bold text-primary">{experience.price} ETB</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ExperienceItem;
